<template>
  <div class="col-sm-12">
    <div class="data-list-item add" @click.stop="$emit('add')">
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">{{ $t('common.add_new') }}</span>
        <font-awesome-icon
          icon="certificate"
          class="card-body-icon"
        />
      </div>
    </div>

      <div clasS="col-12 list-container nopads">
          <Transition name="fade">
              <div v-if="results.length > 0" class="col-sm-12 nopads list-content result-table my-2">
                  <vue3-datatable
                      ref="resultTable"
                      :rows="results"
                      :columns="fields"
                      :pagination="false"
                      :sticky-header="true"
                      height="100%"
                      :sortable="true"
                      skin="bh-table-compact"
                      row-class="routa-table-row"
                      cell-class="routa-table-cell"
                      @row-click="emitEdit"
                  />
              </div>
          </Transition>
      </div>
  </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: 'CertificateTypeList',
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('common.name'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
